<div class="category" (click)="selectCategory()">
  <div class="image">
    <app-image [src]="imageThumb()" />
  </div>
  <div class="title">
    <p class="label">{{name()}}</p>
  </div>
</div>